'use strict';

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
    AppConstants = require('constants/AppConstants'),
    SessionStore = require('stores/SessionStore'),
    Notification = require('components/Notification/Notification'),
    AdminScaffoldingGeneric = require('components/Commons/AdminScaffolding/AdminScaffoldingGeneric'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    FormGroupDropdown = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown'),
    Loading = require('components/Commons/Loading/Loading'),
    ContentUtils = require('utils/ContentUtils'),
    NumberUtils = require('utils/NumberUtils'),
    DateUtils = require('utils/DateUtils'),
    PurchaseOrderUtils = require('utils/PurchaseOrderUtils'),
    InventoryStore = require('stores/InventoryStore'),
    NavigationUtils = require('utils/NavigationUtils'),
    FormGroupTextFieldSuggested = require('components/Commons/BasicForm/FormGroupTextFieldSuggested/FormGroupTextFieldSuggested'),
    Authentication = require('services/Security').Authentication,
    ga = require('react-ga'),
    {map, some, every, filter} = require('lodash/collection'),
    get = require('lodash/object').get,
    {Navigation} = require('react-router'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder');

const VendorReceiveItemAdmin = React.createClass({displayName: "VendorReceiveItemAdmin",
    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            purchaseId: NavigationUtils.getPathParam('purchase-item'),
            vendorId: NavigationUtils.getPathParam('vendors'),
            companyName: NavigationUtils.getQueryParam('companyName'),
            selectedItem: null,
            isEditMode: false
        };
    },

    componentDidMount() {
        this.fetchPurchases();
        ga.pageview('/vendor-receive-item-admin');
    },

    _backToVendor() {
        this.transitionTo('/purchase-item/page/:page', {page:0});
    },

    fetchPurchases(callback) {
        const {purchaseId, vendorId} = this.state;
        const self = this;
        InventoryStore.fetchVendorItems(vendorId, vendorItems => {
            InventoryStore.fetchVendorPurchasesItem(purchaseId, purchases => {
                const purchasesFiltered = filterNonInventoryItemsFromPurchase(ContentUtils.filterEnable(this._hydratePurchases(purchases)));
                const vendorItemsFiltered = filterNonInventoryItems(ContentUtils.filterEnable(vendorItems));
                self.setState(
                    {
                        purchases: purchasesFiltered,
                        vendorItems: vendorItemsFiltered
                    },
                    () => {
                        if (callback) {
                            callback();
                        }
                    }
                );
            });
        });
    },

    _needActionIcon(purchase) {
        const bgColor = purchase.noMoreOnTheWay
          ? 'green'
          : purchase.state === 'MORE_ON_THE_WAY'
          ? 'yellow'
          : purchase.draftMode === true
          ? 'red'
          : 'green';
        return (
            React.createElement("div", null, 
                React.createElement("span", {
                    className: "text-center", 
                    style: {
                        height: '20px',
                        borderRadius: '22px',
                        boxShadow: '1px 2px 4px 0px gray',
                        backgroundColor: bgColor,
                        border: 'solid 0px black',
                        padding: '10px 17px',
                        left: '0',
                        position: 'relative',
                        opacity: '.6'
                    }}
                ), 
                React.createElement("span", {style: {paddingLeft: '10px'}}, AppConstants.getPurchaseStateMapping(t)[get(purchase, 'needAction')])
            )
        );
    },

    _hydratePurchases(purchases) {
        return map(purchases, purchase => {
            const unit = get(purchase, 'vendorItem.supplierUnit') ||  get(purchase, 'vendorItem.item.unit');

            purchase.needAction = getStateText(purchase);

            // add unit label to show in the table
            purchase.amountRequestedWithUnit = `${NumberUtils.formatDecimal(
                purchase.amountRequested
            )} ${unit}`;

            const costPurchaseItem = PurchaseOrderUtils.getPriceOfPurchaseItem(purchase);
            purchase.priceUnitWithCurrency = `${NumberUtils.getCurrentCurrency().symbol} ${NumberUtils.formatDecimal(costPurchaseItem)}`;
            purchase.totalPriceUnitWithCurrency = `${NumberUtils.getCurrentCurrency().symbol} ${NumberUtils.formatDecimal(
                NumberUtils.multiply(get(purchase, 'totalAmountReceived') || get(purchase, 'amountRequested'), costPurchaseItem)
            )}`;

            // set as default next state if the item is already `ORDERED`
            const haveDefaultState = purchase.state === 'ORDERED';
            const haveAmountReceived = NumberUtils.isGreater(purchase.totalAmountReceived, 0);

            if (haveDefaultState) {
                // set auto suggested state
                purchase.suggested = true;
                purchase.state = 'NO_MORE_ON_THE_WAY';

                // set auto suggested amount request
                const haveAmountReceived = !!purchase.totalAmountReceived;

                if (!haveAmountReceived) {
                    purchase.totalAmountReceived = purchase.amountRequested;
                }

                purchase.amountReceivedWithUnit = `${NumberUtils.formatDecimal(
                    purchase.totalAmountReceived || '0'
                )} ${unit}`;

            } else if (haveAmountReceived) {
                purchase.amountReceivedWithUnit = `${NumberUtils.formatDecimal(
                    purchase.totalAmountReceived || '0'
                )} ${unit}`;
            }

            if (!purchase.amountReceivedWithUnit) {
                purchase.amountReceivedWithUnit = `0 ${unit}`;
            }

            purchase.dateReceivedDate = DateUtils.toCurrentTimeZone(
                PurchaseOrderUtils.getLastReceivedDateFromPurchaseOrderItem(purchase),
                SessionStore.getCurrentTimeZone()
            );

            return purchase;
        });
    },

    _onChangePurchase(purchase, onSuccess) {
        InventoryStore.changeVendorPurchaseItemReceivedDraft(
            purchase,
            onSuccess,
            this._onFailure
        );
    },

    _onRowSelection(selectedItem,
                    itemIndex,
                    lastRowScrollPosition,
                    headerActiveFilters) {
        this.setState(
            {
                selectedItem,
                isEditMode: !!selectedItem,
                headerActiveFilters
            },
            () => {
                // stay the position of the scroll after row select when
                // the offset Y es outside of initial viewport page.
                this.getDOMNode().querySelector(
                    '.mui-body-table'
                ).scrollTop = lastRowScrollPosition;
            }
        );
    },

    _onCancel() {
        this.setState({
            selectedItem: null,
            isEditMode: false
        });
    },

    _onFailure(messageInfo) {
        if (messageInfo) {
            const messageError = ContentUtils.formatMessageError(messageInfo);
            Notification.show(messageError);
        }
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    _getBreadcrumbLinks() {
        return [
            {link: '/purchase-item/page/0', param:{page:0}, displayName: t('vendor_purchase_item_label')},
            {displayName: NavigationUtils.getQueryParam('code')}
        ];
    },

    _backToPurchaseItem() {
        this.transitionTo('/purchase-item/page/:page', {page:0});
    },

    _confirmOrdered() {
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('vendor_receive_item_confirmation_add_inventory'),
            () => {
                InventoryStore.confirmVendorPurchaseOrder(
                    this.state.purchaseId,
                    this._onSuccessPurchaseItem,
                    this._onFailurePurchaseItem
                );
            }
        );
    },

    _onSuccessPurchaseItem() {
        this.fetchPurchases(() => {
            Notification.show(t('vendor_receive_item_successfully'), 'success');
        });
    },

    _onDelete() {
    },

    render() {
        const {purchases} = this.state;
        if (!purchases) {
            return React.createElement(Loading, null);
        } else {
            const messages = {
                changeSuccessMessage: t('vendor_receive_item_change_success_message'),
                changeFailureMessage: t('vendor_receive_item_change_failure_message'),
                deleteSuccessMessage: t('vendor_receive_item_delete_success_message'),
                addSuccessMessage: t('vendor_receive_item_add_success_message'),
                addFailureMessage: t('vendor_receive_item_add_failure_message'),
            };
            const addingDisplaySate = (state) => ({
                state,
                displayText: AppConstants.getPurchaseStateMapping(t)[state]
            });
            const contextHolder = this.getContextHolderInstance();
            const {
                selectedItem,
                purchases,
                isEditMode,
                vendorItems
            } = this.state;

            const isClosedOrder = checkIfOrderAreClosed(purchases);
            const isPartiallyReceived = purchases.some(purchase => purchase.amountRequested > purchase.lastAmountReceived);
            const unit = getUnitFromVendorItem(selectedItem);
            const unitWithParenthesis = unit ? '(' + unit + ')' : '(' + t('unit') + ')';
            const shouldBeImmutable = shouldBeImmutableSelectedItem(
                selectedItem,
                isClosedOrder
            );

            let formFieldsEl = selectedItem
                ? [
                    React.createElement(FormGroupTextFieldSuggested, {
                        isDisabled: true, 
                        operationsHolder: contextHolder, 
                        items: vendorItems, 
                        readerAttribute: "item.description", 
                        readerAttributeValue: "id", 
                        writerAttribute: "vendorItemId", 
                        name: t('item'), 
                        label: `${t('item')} ${unitWithParenthesis}`, 
                        isImmutable: true, 
                        isEditMode: isEditMode, 
                        value: get(selectedItem, 'vendorItem'), 
                        onEnter: this._onEnterPress}
                    )
                ]
                : [];

            if (isMoreOnTheWaySelectedItem(selectedItem)) {
                formFieldsEl.push(
                    React.createElement(FormGroupTextfield, {
                        operationsHolder: contextHolder, 
                        readerAttribute: "totalAmountReceived", 
                        writerAttribute: "lastAmountReceived", 
                        additionalValidation: inputValue =>
                            NumberUtils.isNumber(inputValue)
                                ? ''
                                : t('vendor_receive_item_volume_must_number'), 
                        name: t('label_amount'), 
                        value: selectedItem, 
                        label: `${t('vendor_receive_item_amount_received')} ${unitWithParenthesis}`, 
                        isDisabled: true, 
                        isDecimal: true, 
                        isRelaxedText: true, 
                        isEditMode: isEditMode, 
                        onEnter: this._onEnterPress}
                    )
                );

                formFieldsEl.push(
                    React.createElement(FormGroupTextfield, {
                        isDisabled: shouldBeImmutable, 
                        value: {totalAmountReceived: 0}, 
                        operationsHolder: contextHolder, 
                        readerAttribute: "totalAmountReceived", 
                        writerAttribute: "lastAmountReceived", 
                        additionalValidation: inputValue =>
                            NumberUtils.isNumber(inputValue)
                                ? ''
                                : t('vendor_receive_item_volume_must_number'), 
                        name: t('label_amount'), 
                        label: `${t('vendor_receive_item_new_amount_received')} ${unitWithParenthesis}`, 
                        isRelaxedText: true, 
                        isDecimal: true, 
                        isEditMode: isEditMode, 
                        onEnter: this._onEnterPress}
                    )
                );
            } else {
                formFieldsEl.push(
                    React.createElement(FormGroupTextfield, {
                        isDisabled: shouldBeImmutable, 
                        operationsHolder: contextHolder, 
                        readerAttribute: "totalAmountReceived", 
                        writerAttribute: "lastAmountReceived", 
                        additionalValidation: inputValue =>
                            NumberUtils.isNumber(inputValue)
                                ? ''
                                : t('vendor_receive_item_volume_must_number'), 
                        name: t('label_amount'), 
                        value: selectedItem, 
                        isDecimal: true, 
                        label: `${t('vendor_receive_item_amount_received')} ${unitWithParenthesis}`, 
                        isRelaxedText: true, 
                        isEditMode: isEditMode, 
                        onEnter: this._onEnterPress}
                    )
                );
            }
    
            const currentSelectedSection = selectedItem && selectedItem.state
              ? AppConstants.getPurchaseStateMapping(t)[selectedItem.state]
              : '';
    
            const currentSelectedValue = currentSelectedSection
              ? Object.assign({}, selectedItem, {displayText: currentSelectedSection})
              : selectedItem;
    
            formFieldsEl.push(
                React.createElement(FormGroupDropdown, {
                    isDisabled: shouldBeImmutable, 
                    items: shouldShowOnlyNoMoreOnTheWay(selectedItem)
                      ? AppConstants.ONLY_NO_MORE_ON_THE_WAY.map(addingDisplaySate)
                      : AppConstants.RECEIVE_STATES_ITEMS.map(addingDisplaySate), 
                    
                    operationsHolder: contextHolder, 
                    readerAttribute: "displayText", 
                    writerAttribute: "state", 
                    customReaderWriterAttribute: "state", 
                    readerAttributeValue: "state", 
                    name: t('vendor_receive_item_column_email_status'), 
                    label: t('vendor_receive_item_status_received'), 
                    value: currentSelectedValue || 'RECEIVED', 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                )
            );

            let additionalButtons = [
                {
                    permission: 'CONFIRM_RECEIVE',
                    type: 'CHANGE',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('back'), 
                            icon: "subdirectory_arrow_left", 
                            type: "icon", 
                            onClick: this._backToPurchaseItem}
                        )
                    )
                },
                {
                    permission: 'CONFIRM_RECEIVE',
                    type: 'NEW',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('back'), 
                            icon: "subdirectory_arrow_left", 
                            type: "icon", 
                            onClick: this._backToPurchaseItem}
                        )
                    )
                }
            ];

            const haveSomePurchaseItem = ContentUtils.isNotEmptyArray(
                purchases
            );

            const haveSomePurchaseItemPending = some(
                purchases,
                purchase =>
                    isDraftPurchase(purchase) ||
                    isSuggestedOrder(purchase)
            );
            const needSendEmailBefore = some(
                purchases,
                purchase =>
                    isPendingPurchase(purchase)
            );

            if (!needSendEmailBefore && haveSomePurchaseItem && haveSomePurchaseItemPending) {
                additionalButtons.push({
                    type: 'NEW',
                    permission: 'CONFIRM_RECEIVE',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('vendor_receive_item_label_confirm_received'), 
                            icon: "local_shipping", 
                            type: "icon", 
                            onClick: this._confirmOrdered}
                        )
                    )
                });
            }

            return (
                React.createElement(AdminScaffoldingGeneric, {
                    messages: messages, 
                    moduleName: "ADMIN_PURCHASE", 
                    additionalButtons: additionalButtons, 
                    title: 
                        isClosedOrder ? (isPartiallyReceived ? t('vendor_receive_item_status_close_resolved') : t('vendor_receive_item_status_close_completed'))
                            : isEditMode
                            ? t('vendor_receive_item_receive_existing_item')
                            : t('vendor_receive_item_receive_item'), 
                    
                    contextHolder: contextHolder, 
                    value: selectedItem, 
                    fetchItems: this.fetchPurchases, 
                    headerFields: formFieldsEl, 
                    onChange: 
                        isClosedOrder || shouldBeImmutable
                            ? undefined
                            : this._onChangePurchase, 
                    
                    onCancel: this._onCancel, 
                    onDelete: 
                        shouldBeImmutable || isClosedOrder
                            ? undefined
                            : this._onDelete, 
                    
                    addEnterKeyDown: this._addEnterKeyDown, 
                    breadcrumb: this._getBreadcrumbLinks()
                }, 
                    React.createElement(AdminScaffoldingTable, {
                        onRowSelection: this._onRowSelection, 
                        value: selectedItem, 
                        sortByColumn: "vendorItem.item.description", 
                        filteredColumns: [
                            'vendorItem.item.description',
                            'amountRequestedWithUnit',
                            'amountReceivedWithUnit',
                            'priceUnitWithCurrency',
                            'totalPriceUnitWithCurrency',
                            'dateReceivedDate',
                            'needAction'
                        ], 
                        displayAttributes: [
                            'vendorItem.item.description',
                            'amountRequestedWithUnit',
                            'amountReceivedWithUnit',
                            'priceUnitWithCurrency',
                            'totalPriceUnitWithCurrency',
                            'dateReceivedDate',
                            'displayState',
                            {
                                getHTML: this._needActionIcon
                            }
                        ], 
                        columnNames: [
                            t('vendor_receive_item_column_item'),
                            t('vendor_receive_item_column_amt_requested'),
                            t('vendor_receive_item_column_amt_received'),
                            t('vendor_receive_item_column_unit_price'),
                            t('vendor_receive_item_column_total_price'),
                            t('vendor_receive_item_column_date_received'),
                            t('vendor_receive_item_column_email_status'),
                            t('vendor_receive_item_column_action')
                        ]
                    }, 
                        purchases.map(purchase => {
                            purchase.displayState = AppConstants.getPurchaseStateMapping(t)[purchase.state];
                            return purchase;
                        })
                    )
                )
            );
        }
    }
});


function checkIfOrderAreClosed(purchases) {
    return every(purchases, purchase => {
        const haveCloseableState = 'REJECT_REMAINDER' === purchase.state || 'NO_MORE_ON_THE_WAY' === purchase.state;
        const isNonSuggestedItem = purchase.suggested === false || purchase.suggested === undefined;
        const isNonDraftMore = purchase.draftMode === false || purchase.draftMode === undefined;

        return haveCloseableState && isNonSuggestedItem && isNonDraftMore;
    });
}

function shouldBeImmutableSelectedItem(selectedItem, isClosedOrder) {
    // once have next state of MORE_ON_THE_WAY should not return it
    const currentStateItem = get(selectedItem, 'state', '');
    const isDraftMode = get(selectedItem, 'draftMode', '');
    const itemSuggested = get(selectedItem, 'suggested', false);
    let shouldBeImmutable = false;

    if (isClosedOrder) {
        // enter here means the order could not be changed any more,
        // because is already closed
        shouldBeImmutable = true;
    } else if (isDraftMode) {
        shouldBeImmutable = false;
    } else {
        if (itemSuggested) {
            // enter here means the item was pre-defined by the system
            // but is not saved the suggested state of the item
            shouldBeImmutable = false;
        } else if (!ContentUtils.isEmptyText(currentStateItem)) {
            // enter here ask if current item selection have
            // a non returned state.
            shouldBeImmutable =
                currentStateItem === 'NO_MORE_ON_THE_WAY' ||
                currentStateItem === 'REJECT_REMAINDER';
        }
    }

    return shouldBeImmutable;
}

function isSuggestedOrder(purchase) {
    return get(purchase, 'suggested');
}

function isPendingPurchase(purchase) {
    return get(purchase, 'state') === 'PENDING';
}

function isDraftPurchase(purchase) {
    return get(purchase, 'draftMode');
}

function shouldShowOnlyNoMoreOnTheWay(selectedItem){
    return NumberUtils.isGreater(get(selectedItem, 'lastTotalAmountReceived'), get(selectedItem, 'amountRequested'));
}

function isMoreOnTheWaySelectedItem(selectedItem) {
    return get(selectedItem, 'state', '') === 'MORE_ON_THE_WAY';
}

function getStateText(purchase) {
    const state = get(purchase, 'state');

    if (state === 'NO_MORE_ON_THE_WAY') {
        return 'CLOSED_COMPLETE';
    } else if (state === 'REJECT_REMAINDER') {
        return 'CLOSED_INCOMPLETE';
    } else if (state === 'MORE_ON_THE_WAY'){
        return 'OPEN_INCOMPLETE';
    } else {
        return state;
    }
}

function getUnitFromVendorItem(vendorItem) {
    return get(vendorItem, 'vendorItem.supplierUnit') ||  get(vendorItem, 'vendorItem.item.unit');
}

function filterNonInventoryItems(vendorItems) {
    return filter(vendorItems, vendorItem => get(vendorItem, 'item.category') !== AppConstants.ITEM_CATEGORY_NON_INVENTORY);
}
function filterNonInventoryItemsFromPurchase(purchases) {
    return filter(purchases, purchase => get(purchase, 'vendorItem.item.category') !== AppConstants.ITEM_CATEGORY_NON_INVENTORY);
}

module.exports = VendorReceiveItemAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/VendorPurchaseAdmin/VendorReceiveItemAdmin.jsx
 **/